import React from "react";

// Styles
import styles from "./index.module.scss";

interface IProps {
	title: string;
	children?: React.ReactNode;
}

const TitleBox: React.FC<IProps> = (props: IProps) => {
	return (
		<div className={styles["title-box"]}>
			<h4>{props.title}</h4>
		</div>
	);
};

export default TitleBox;
